import { jsPDF } from "jspdf";
import { Hora } from "../Fecha";
import { firmaSubarrendatario, identificacionSubarrendatario, nombreParaArchivo } from "./ParteContratante";

export const ContratoBodega = (datos, img) => {
	let { fecha } = datos;
	
	if (fecha === "hoy") {
		fecha = Hora();
	}
	const doc = new jsPDF();
	doc.setFont("arial");
	doc.setFontSize(20);
	doc.text("CONTRATO DE SUBARRIENDO BODEGA", 100, 25, { align: "center" });
	doc.line(32, 26, 168, 26);
	doc.setFontSize(12);
	doc.setLineHeightFactor(1.5);
	var text1 = `En Santiago de Chile, a ${fecha}, entre Asesorias e Inversiones DN SpA, Rut
77.526.796-8, representada legalmente por Rodrigo Andres Araya Montalvan, Rut 15.380.582-2, domiciliado
en Av. Nueva Providencia 1945, oficina 807, Comuna de Providencia, como “SUB ARRENDADOR", y, don(a)
${identificacionSubarrendatario(datos)}, como el “SUB ARRENDATARIO” quienes han
convenido celebrar el siguiente CONTRATO DE SUBARRENDAMIENTO DE BODEGA que se regirá por las
cláusulas siguientes, y en silencio de ellas, por las disposiciones del Código Civil.

Los comparecientes, mayores de edad y plenamente capaces, quienes acreditan su identidad con la cédula respectiva, exponen lo siguiente:`;
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 40, splitTitle1);


	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("PRIMERO: OBJETO DEL CONTRATO", 10, 107);
	doc.line(10, 108, 88, 108);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text2 = `Por este acto, el ARRENDADOR da en arriendo un espacio de bodega 54, ubicado en Avenida Nueva Providencia 1945, oficina 807, comuna de Providencia, Santiago, destinado exclusivamente a recepción y almacenaje de cajas, paquetes o encomiendas de dimensiones máximas 50 x 50 cm por bulto.

Queda expresamente prohibido almacenar materiales inflamables, corrosivos, explosivos o cualquier elemento que pueda dañar el inmueble, al arrendador o a terceros.`;
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 114, splitTitle2);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("SEGUNDO: SERVICIO Y VALORES", 10, 155);
	doc.line(10, 156, 81, 156);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text3 = `El servicio de bodegaje se prestará sujeto a los siguientes valores:

- $5.000 (IVA incluido) por día completo de permanencia, por bulto.
- $2.500 (IVA incluido) por medio día de permanencia, por bulto.
- $120.000 (IVA incluido) tarifa mensual fija para un bulto de máximo 50 x 50 cm.

Condiciones especiales:
- Solo se permitirá un máximo de 5 bultos por empresa.
- La disponibilidad del servicio estará sujeta a la capacidad de la bodega, por lo que el ingreso de bultos será confirmado según el espacio disponible al momento de la solicitud.

El cobro aplica desde la notificación de la recepción del bulto, sea por correo electrónico u otro medio acordado.`;
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 164, splitTitle3);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("TERCERO: RENTA Y FORMA DE PAGO", 10, 250);
	doc.line(10, 251, 95, 251);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text4 = `La renta correspondiente será cancelada durante los primeros cinco días de cada mes mediante cualquiera de las siguientes modalidades:`;
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 258, splitTitle4);

	doc.addPage();

	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text1 = `a) Depósito o transferencia en la cuenta corriente del ARRENDADOR:
	- Banco: Banco Estado
	- Nombre: Asesorías e Inversiones DN SpA
	- RUT: 77.526.796-8
	- Nº de cuenta: 90270930912
	- Correo de pagos: pagos@denegocios.cl

b) Pago en efectivo en el domicilio del arrendador.

El atraso en el pago generará intereses corrientes hasta la fecha del pago efectivo.
El presente contrato empezó a regir el día ${fecha} y durará 12 meses de corrido. No obstante, lo anteriormente señalado, este contrato se renovará sucesiva y automáticamente en períodos iguales al contratado, si ninguna de las partes da aviso a la otra con a lo menos 15 días de anticipación a la fecha de su vencimiento, por medio escrito, su deseo de poner término al presente contrato, e informando término de giro ante Servicio de Impuestos Internos.
El Cliente puede rescindir contrato antes de lo anteriormente estipulado, es decir, el cliente podrá dejar el contrato de arriendo antes del plazo de 12 meses. Para ello deberá dar aviso a través de correo a contacto@denegocios.cl y/o a soporte@denegocios.cl de que ya no utilizará nuestro domicilio y seguir las indicaciones que se le entregarán en dicho momento.`;
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 20, splitTitle1);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("CUARTO: TERMINACIÓN ANTICIPADA", 10, 145);
	doc.line(10, 146, 91, 146);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text2 = `El ARRENDADOR podrá poner término inmediato al contrato en los siguientes casos:

1. Incumplimiento de pago por parte del arrendatario.
2. Destinar el espacio arrendado a fines distintos al bodegaje.
3. Mal uso de la bodega o infracción a las normas aquí pactadas.`;
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 152, splitTitle2);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("QUINTO: RESPONSABILIDAD", 10, 190);
	doc.line(10, 191, 70, 191);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text3 = `El arrendador no se responsabiliza por el contenido de los bultos, pérdidas, deterioro, multas o perjuicios derivados del almacenaje. La responsabilidad total por embalaje, contenido, retiro y custodia recae en el arrendatario.`;
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 198, splitTitle3);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("SEXTO: GESTIÓN DE LA CORRESPONDENCIA", 10, 225);
	doc.line(10, 226, 107, 226);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text4 = `El arrendatario autoriza a Asesorías e Inversiones DN SpA a eliminar todo bulto o caja recibidos a nombre de su empresa y/o de sus representantes, que no haya sido retirados en un plazo máximo de 12 meses o 15 dias dependiendo del plazo estipulado en el contrato a partir de la notificación correspondiente.`;
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 232, splitTitle4);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("SÉPTIMO: DOMICILIO Y COMPETENCIA", 10, 255);
	doc.line(10, 256, 95, 256);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text5 = `Para todos los efectos derivados del presente contrato, las partes fijan domicilio en la ciudad de Santiago y prorrogan competencia para ante sus Tribunales de Justicia.`;
	var splitTitle5 = doc.splitTextToSize(text5, 190);
	doc.text(10, 261, splitTitle5);

	doc.addPage();

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("OCTAVO: MULTAS, GASTOS Y COSTAS", 10, 20);
	doc.line(10, 21, 92, 21);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text1 = `Se conviene expresamente que por el no pago oportuno de la renta convenida, el SUB ARRENDATARIO, pagará una multa igual al interés máximo convencional para operaciones reajustables, multa que regirá desde el día siguiente del plazo que tienen para hacerlo y hasta la fecha que se realice el pago efectivo de la obligación.
En caso de mensualidades con 30 días de atraso, se aplicará gasto de cobranza a partir del día 31 de mora, como porcentaje de la mensualidad adeudada.

En caso de incumplimiento en el pago de las rentas convenidas, el SUB ARRENDADOR queda expresamente facultado para informar los datos del SUB ARRENDATARIO y de su representante legal al Boletín Comercial u otros sistemas de información comercial, previa notificación por escrito enviada al domicilio físico o correo electrónico registrado en este contrato. El SUB ARRENDATARIO tendrá un plazo de 5 días hábiles, contados
desde la fecha de recepción de la notificación, para subsanar la deuda pendiente.

El SUB ARRENDATARIO y su representante legal aceptan y consienten expresamente que, en caso de mora o simple retardo en el cumplimiento de sus obligaciones contractuales, sus datos personales sean tratados,
utilizados y reportados a sistemas de información comercial de acuerdo con lo establecido en la Ley N° 19.628 sobre Protección de la Vida Privada, garantizándose sus derechos de acceso, rectificación, cancelación y oposición conforme a la normativa vigente.`;
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 27, splitTitle1);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("NOVENO: EJEMPLARES", 10, 140);
	doc.line(10, 141, 61, 141);
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	var text2 = `El presente contrato se firma en dos ejemplares de idéntico tenor, quedando uno en poder de cada parte.`;
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 146, splitTitle2);

	doc.line(10, 180, 90, 180);
	doc.text("Asesorias e Inversiones DN SpA", 10, 185);
	doc.text("77.526.796-8", 10, 190);
	doc.text("P.p Rodrigo Andres Araya Montalvan", 10, 195);
	doc.text("15.380.582-2", 10, 200);
	firmaSubarrendatario(doc, datos, 229);



	doc.save(`Contrato Bodega para ${nombreParaArchivo(datos)}.pdf`);
};